import { combineEpics, ofType } from "redux-observable";
import { of, from, Observable, mergeMap, catchError } from "rxjs";
import { AnyAction } from "redux";
import { RootStateOrAny } from "react-redux";
import { failedRequest, succeededRequest } from "../request/action";

import { errorString } from "../../utils/strings";

import {
  updateLogSuccess,
  updateLogFailure,
  getLogsSuccess,
  getLogsFailure,
} from "./actions";

import {
  GET_LOGS_REQUEST,
  UPDATE_LOGS_FAILURE,
  UPDATE_LOGS_REQUEST,
} from "./actionTypes";

import {
  getLogsUsecase,
  updateLogUsecase,
} from "../../core/usecases/interactors/log";
import { data as constants } from "../../constants";

export const updateLogsEpic = (
  action$: Observable<AnyAction>,
  _state$: RootStateOrAny,
  {
    logsInteractor: { updateLog },
  }: { logsInteractor: { updateLog: updateLogUsecase } }
) =>
  action$.pipe(
    ofType(UPDATE_LOGS_REQUEST),
    mergeMap(({ payload: { applicantId, logs } }) => {
      return from(updateLog(applicantId, logs)).pipe(
        mergeMap(() => {
          return of(updateLogSuccess(), succeededRequest(UPDATE_LOGS_REQUEST));
        }),
        catchError((error) => {
          const errorMessage = errorString(error);
          errorMessage.includes(constants.commonNetworkError) &&
            window.location.reload();
          return of(
            updateLogFailure(errorMessage),
            failedRequest(UPDATE_LOGS_FAILURE, errorMessage)
          );
        })
      );
    })
  );

export const getLogsEpic = (
  action$: Observable<AnyAction>,
  _state$: RootStateOrAny,
  {
    logsInteractor: { getLogs },
  }: { logsInteractor: { getLogs: getLogsUsecase } }
) =>
  action$.pipe(
    ofType(GET_LOGS_REQUEST),
    mergeMap(({ payload: { applicantId } }) => {
      return from(getLogs(applicantId)).pipe(
        mergeMap((data: any) => {
          return of(getLogsSuccess(data));
        }),
        catchError((error) => {
          const errorMessage = errorString(error);
          errorMessage.includes(constants.commonNetworkError) &&
            window.location.reload();
          return of(getLogsFailure(errorMessage));
        })
      );
    })
  );

//@ts-ignore
export default combineEpics(updateLogsEpic, getLogsEpic);
